import script from "./AnnouncementTypes.vue?vue&type=script&setup=true&lang=js"
export * from "./AnnouncementTypes.vue?vue&type=script&setup=true&lang=js"

import "./AnnouncementTypes.vue?vue&type=style&index=0&id=5b0d8d01&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b0d8d01"]])

export default __exports__